import HTMLReactParser from 'html-react-parser';
import LocationListingContext, { type LocationListingContextProps } from '../LocationListingContext';
import { type FC, useContext } from 'react';
import { filterItemsById } from '../LocationListingHelpers';
import MapCard from '4-sections/FilteredListings/AssetsListing/Map/MapCard';
import { type LocationMapItem } from './ListingMap';

interface MapPanelProps {
    items: LocationMapItem[];
}

const MapPanel: FC<MapPanelProps> = ({ items }) => {
    const {
        activeItemId,
        setActiveItemId,
        label,
    } = useContext(
        LocationListingContext
    ) as LocationListingContextProps;

    // If user is not performing search then just show 1 activeItemId if there's activeItemId
    // Otherwise if user perform search or nearby location show all from search results
    const filteredItems = (activeItemId) ?
        filterItemsById(items, activeItemId) :
        [];

    const mapPanelClass = `map-panel ${activeItemId ? 'is-active' : ''}`;

    return (
        <div className={mapPanelClass}>
            <div className="map-panel-container">
                {filteredItems.map(({ name, id, img, description, href }) => {
                    return (
                        <MapCard
                            key={id}
                            img={img}
                            title={name}
                            icon="map"
                            onCloseButtonClick={(): void => {
                                setActiveItemId('');
                            }}
                            link={{
                                label: label.readMoreCardLabel,
                                href,
                            }}
                        >
                            {HTMLReactParser(description)}
                        </MapCard>
                    );
                })}
            </div>
        </div>
    );
};

export default MapPanel;
